import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

function RuleItem({
  number,
  title,
  description,
}: {
  number: string;
  title: string;
  description: string;
}) {
  return (
    <View style={styles.ruleItem}>
      <View style={styles.numberContainer}>
        <Text.Heading type="hero" style={styles.ruleNumber}>
          {number}
        </Text.Heading>
      </View>
      <View style={styles.ruleTextContainer}>
        <Text.Ui size="md" weight="semibold">
          {title}
        </Text.Ui>
        <Text.Ui size="sm" style={styles.ruleDescription}>
          {description}
        </Text.Ui>
      </View>
    </View>
  );
}

export function EligibilityRules() {
  return (
    <View style={styles.container}>
      <Text.Ui size="lg" weight="semibold">
        Eligibility Rules
      </Text.Ui>
      <Text.Ui size="sm" style={styles.description}>
        To qualify for the birthday reward, you need to meet the following requirements:
      </Text.Ui>

      <View style={styles.rulesList}>
        <RuleItem
          number="1"
          title="Recent Purchase Required"
          description="Have ordered in the last 6 months (excluding orders within 7 days of birthday)."
        />
        <RuleItem
          number="2"
          title="Minimum Purchase Amount"
          description="The recent order must have exceed the total amount of $1."
        />
        <RuleItem
          number="3"
          title="Purchase Identification"
          description="Recent order must have been linked to you online or in-restaurant via phone number."
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
  },
  description: {
    marginTop: 8,
  },
  rulesList: {
    paddingTop: 16,
    gap: 16,
  },
  ruleItem: {
    flexDirection: 'row',
    backgroundColor: tokens.colors.$houseLight,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  numberContainer: {
    width: 48,
    height: 52,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity04,
  },
  ruleNumber: {
    color: tokens.colors.$houseRed,
  },
  ruleTextContainer: {
    flex: 1,
    paddingLeft: 12,
  },
  ruleDescription: {
    marginTop: 4,
  },
});
